<template>
<router-link class="featured-item" :to="to">

      <div class="flex-box">
        <h2 class="title">{{title}}</h2>
        
      </div>
      <div v-if="image_src" class="poster-image" :style="computePosterStyle">
        
        <ratio-image :src="image_src">
        </ratio-image>
       
        
        
     </div>

      
      




     <div class="text-container">
      
       <div class="text" v-if="text">{{text}}
            
        </div>
    </div>
    <div class="clear-float"></div>


    <div v-if="readMore" class="lees-meer">{{$t('language.lees_meer')}}</div>
    
    <div class="counters">
        <ui-chip v-if="item.video_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="film">{{item.video_count}}</ui-chip>
        <ui-chip v-if="item.photo_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="image">{{item.photo_count}}</ui-chip>
        <ui-chip v-if="item.pdf_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="file-pdf">{{item.pdf_count}}</ui-chip>
        <ui-chip v-if="item.mp3_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="music">{{item.mp3_count}}</ui-chip>
      </div>
    
    
    </router-link>
</template>

<script>

import RatioImage from '../RatioImage.vue';
import UiChip from '../UiChip.vue';


export default {
  name: 'featured-news-item',
  props:{
    to:{default:"/"},
    title:{default:undefined},
    text:{default:undefined},
    image_src:{default:undefined},
    readMore:{default:false},
    index:{default:0},
    item:{default:{}}
  },
  data:function(){
    return {
    }
  },
  components:{
    RatioImage,
    UiChip,
  },
  methods:{
    function(){
      
    }
  },
  computed:{
    
    computePosterStyle(){
      if(this.index==0){
        // big news poster
        return {float:'none', width:'100%!important'}
      }
      return {};
    }
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.featured-item{
  text-decoration: none;
  cursor:pointer;
  color:inherit;
  display:block;
  position:relative;
}

.flex-box{
  display:flex;
  justify-content: center;
}
.title{
  flex:1;
}
.text{
  line-height:1.1em;
   margin-bottom:10px;
}
img{
  border-radius:2px;
}

.clear-float{
  clear:both;
}
.poster-image{
  float:left;
  margin-right:10px;
  width:140px;
  margin-bottom:10px;
}
h2{
  margin:0px;
  margin-bottom:10px;
  font-size:1.2em;
  line-height:1em;
}


.lees-meer{
  margin-bottom:10px;
 font-weight:bold;
 color:#707070;
 font-size: .8em;
}
.counters{
  text-align:right;
  font-size:1em;
}
.counter-icon{
  margin-right:3px;
}


</style>

